import _classCallCheck from "/builder/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builder/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import composeRefs from '@seznam/compose-react-refs';
import { matchSorter } from 'match-sorter';
import { createElement, useCallback, useContext, cloneElement, createContext, useMemo, useEffect, forwardRef, useRef, useState, createRef } from 'react';
import { createPortal } from 'react-dom';
import { useMenuState, MenuButton, Menu, MenuSeparator, useMenuBarState, MenuBar as MenuBar$1, MenuGroup as MenuGroup$1, MenuItem } from 'reakit/Menu';
import useLayoutEffect from 'use-isomorphic-layout-effect';
import { cx, isString, deepMerge, isFunction, isArray, isEqual, getShortcutSymbols, includes, capitalize, invariant, ErrorConstant, isEmptyArray, clamp } from '@remirror/core';
import { getPositioner } from '@remirror/extension-positioner';
import { useI18n, useRemirrorContext, useCommands, useChainedCommands, useHelpers, useActive } from '@remirror/react-core';
import { useEditorFocus, usePositioner, useSuggest, useEmoji, useMentionAtom } from '@remirror/react-hooks';
import { ComponentsTheme, createThemeVariables, THEME, ExtensionPositionerTheme, ExtensionEmojiTheme, ExtensionMentionAtomTheme } from '@remirror/theme';
import { Box } from 'reakit/Box';
import { useTooltipState, TooltipReference, Tooltip } from 'reakit/Tooltip';
import _createForOfIteratorHelper from '@babel/runtime/helpers/esm/createForOfIteratorHelper';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { I as Icon } from './icons-base-c4a04862.browser.esm.js';
export { G as GenIcon, I as Icon, a as IconBase } from './icons-base-c4a04862.browser.esm.js';
import { Provider } from 'reakit';
import { unstable_getIn } from 'reakit/Form/utils/getIn';
import { palette as palette$1 } from 'reakit-system-palette/palette';
import { Button } from 'reakit/Button';
export { Button } from 'reakit/Button';
import { Group } from 'reakit/Group';
import { useToolbarState, Toolbar as Toolbar$1, ToolbarItem, ToolbarSeparator as ToolbarSeparator$1 } from 'reakit/Toolbar';
import { VisuallyHidden } from 'reakit/VisuallyHidden';
import { createPopper } from '@popperjs/core';
import { isUA } from 'reakit-utils/dom';
import { shallowEqual } from 'reakit-utils/shallowEqual';
import { useCompositeState, Composite, CompositeGroup, CompositeItem } from 'reakit/Composite';
import { palette } from '@remirror/extension-text-color';
import { useDialogState, Dialog, DialogBackdrop } from 'reakit/Dialog';
import usePrevious from 'use-previous';
import { ReactComponentMessages } from '@remirror/messages';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _classPrivateFieldSet from '@babel/runtime/helpers/esm/classPrivateFieldSet';
import _classPrivateFieldGet from '@babel/runtime/helpers/esm/classPrivateFieldGet';
import '@remirror/icons';

var ColorPickerComponent = function ColorPickerComponent(props) {
  var _props$palette = props.palette,
      palette$1 = _props$palette === void 0 ? palette : _props$palette,
      onSelect = props.onSelect,
      selectedColor = props.selectedColor;

  var _useI18n = useI18n(),
      t = _useI18n.t;

  var compositeState = useCompositeState({
    loop: true
  });

  var _palette = palette$1(t),
      black = _palette.black,
      transparent = _palette.transparent,
      white = _palette.white,
      hues = _palette.hues;

  return /*#__PURE__*/jsxs(Grid, {
    compositeState: compositeState,
    children: [/*#__PURE__*/jsxs(GridRow, {
      compositeState: compositeState,
      children: [/*#__PURE__*/jsx(GridCell, _objectSpread(_objectSpread({}, black), {}, {
        compositeState: compositeState,
        selected: black.color === selectedColor,
        onSelect: onSelect
      })), /*#__PURE__*/jsx(GridCell, _objectSpread(_objectSpread({}, white), {}, {
        compositeState: compositeState,
        selected: white.color === selectedColor,
        onSelect: onSelect
      })), /*#__PURE__*/jsx(GridCell, _objectSpread(_objectSpread({}, transparent), {}, {
        compositeState: compositeState,
        selected: transparent.color === selectedColor,
        onSelect: onSelect
      }))]
    }), Object.values(hues).map(function (hueMap, index) {
      return /*#__PURE__*/createElement(ColorPickerHue, _objectSpread(_objectSpread({}, hueMap), {}, {
        compositeState: compositeState,
        selectedColor: selectedColor,
        onSelect: onSelect,
        key: index
      }));
    })]
  });
};

var ColorPickerHue = function ColorPickerHue(props) {
  var label = props.label,
      hues = props.hues,
      compositeState = props.compositeState,
      selectedColor = props.selectedColor,
      onSelect = props.onSelect;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [label, /*#__PURE__*/jsx(GridRow, {
      compositeState: compositeState,
      children: hues.map(function (hue, index) {
        return /*#__PURE__*/createElement(GridCell, _objectSpread(_objectSpread({}, hue), {}, {
          compositeState: compositeState,
          selected: hue.color === selectedColor,
          onSelect: onSelect,
          key: index
        }));
      })
    })]
  });
};

var Grid = function Grid(props) {
  return /*#__PURE__*/jsx(Composite, _objectSpread({
    role: "grid"
  }, props.compositeState));
};

var GridRow = function GridRow(props) {
  return /*#__PURE__*/jsx(CompositeGroup, _objectSpread({
    role: "row"
  }, props.compositeState));
};

var GridCell = function GridCell(props) {
  var color = props.color,
      label = props.label,
      selected = props.selected,
      compositeState = props.compositeState,
      onSelect = props.onSelect,
      className = props.className;
  var tooltipState = useTooltipState({
    gutter: 5
  });
  var onClick = useCallback(function () {
    return onSelect(color);
  }, [color, onSelect]);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(TooltipReference, _objectSpread(_objectSpread({}, tooltipState), {}, {
      children: /*#__PURE__*/jsx(CompositeItem, _objectSpread(_objectSpread({
        as: "div",
        role: "gridcell"
      }, compositeState), {}, {
        style: {
          backgroundColor: color
        },
        className: cx(ComponentsTheme.COLOR_PICKER_CELL, className, selected && ComponentsTheme.COLOR_PICKER_CELL_SELECTED),
        onClick: onClick
      }))
    })), /*#__PURE__*/jsx(Tooltip, _objectSpread(_objectSpread({}, tooltipState), {}, {
      children: label
    }))]
  });
};

var CommandIconComponent = function CommandIconComponent(props) {
  var icon = props.icon,
      wrapperClass = props.wrapperClass;

  if (isString(icon)) {
    return /*#__PURE__*/jsx(Icon, {
      name: icon
    });
  } // Render when the icon is a complex icon.


  return /*#__PURE__*/jsxs(Box, {
    as: "span",
    className: wrapperClass,
    children: [icon.sup && icon.sup, /*#__PURE__*/jsx(Icon, {
      name: icon.name
    }), icon.sub && icon.sub]
  });
};

var _excluded$b = ["fill", "palette"],
    _excluded2$7 = ["unstable_system"];

function useButtonOptions(_ref) {
  var _ref$unstable_system = _ref.unstable_system;
  _ref$unstable_system = _ref$unstable_system === void 0 ? {} : _ref$unstable_system;

  var _ref$unstable_system$ = _ref$unstable_system.fill,
      fill = _ref$unstable_system$ === void 0 ? 'opaque' : _ref$unstable_system$,
      _ref$unstable_system$2 = _ref$unstable_system.palette,
      palette = _ref$unstable_system$2 === void 0 ? 'primary' : _ref$unstable_system$2,
      system = _objectWithoutProperties(_ref$unstable_system, _excluded$b),
      options = _objectWithoutProperties(_ref, _excluded2$7);

  return _objectSpread({
    unstable_system: _objectSpread({
      fill: fill,
      palette: palette
    }, system)
  }, options);
}

function useButtonProps(_) {
  var htmlProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _objectSpread(_objectSpread({}, htmlProps), {}, {
    className: cx(ComponentsTheme.BUTTON, htmlProps.className)
  });
}

var _excluded$a = ["fill", "palette"],
    _excluded2$6 = ["unstable_system"];

function useCompositeItemOptions(_ref) {
  var _ref$unstable_system = _ref.unstable_system;
  _ref$unstable_system = _ref$unstable_system === void 0 ? {} : _ref$unstable_system;

  var _ref$unstable_system$ = _ref$unstable_system.fill,
      fill = _ref$unstable_system$ === void 0 ? 'opaque' : _ref$unstable_system$,
      _ref$unstable_system$2 = _ref$unstable_system.palette,
      palette = _ref$unstable_system$2 === void 0 ? 'primary' : _ref$unstable_system$2,
      system = _objectWithoutProperties(_ref$unstable_system, _excluded$a),
      options = _objectWithoutProperties(_ref, _excluded2$6);

  return _objectSpread({
    unstable_system: _objectSpread({
      fill: fill,
      palette: palette
    }, system)
  }, options);
}

function useCompositeItemProps(_) {
  var htmlProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _objectSpread({}, htmlProps);
}

var _excluded$9 = ["palette", "fill"],
    _excluded2$5 = ["unstable_system"];

function useDialogOptions(_ref) {
  var _ref$unstable_system = _ref.unstable_system;
  _ref$unstable_system = _ref$unstable_system === void 0 ? {} : _ref$unstable_system;

  var _ref$unstable_system$ = _ref$unstable_system.palette,
      palette = _ref$unstable_system$ === void 0 ? 'background' : _ref$unstable_system$,
      _ref$unstable_system$2 = _ref$unstable_system.fill,
      fill = _ref$unstable_system$2 === void 0 ? 'opaque' : _ref$unstable_system$2,
      system = _objectWithoutProperties(_ref$unstable_system, _excluded$9),
      options = _objectWithoutProperties(_ref, _excluded2$5);

  return _objectSpread(_objectSpread({}, options), {}, {
    unstable_system: _objectSpread({
      palette: palette,
      fill: fill
    }, system)
  });
}

function useDialogProps(_) {
  var htmlProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _objectSpread(_objectSpread({}, htmlProps), {}, {
    className: cx(ComponentsTheme.DIALOG, htmlProps.className)
  });
}

function useDialogBackdropProps(_) {
  var htmlProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _objectSpread(_objectSpread({}, htmlProps), {}, {
    className: cx(ComponentsTheme.DIALOG_BACKDROP, htmlProps.className)
  });
}

var _excluded$8 = ["fill"],
    _excluded2$4 = ["unstable_system"],
    _excluded3$1 = ["unstable_system"],
    _excluded4$1 = ["fill"],
    _excluded5 = ["unstable_system"],
    _excluded6 = ["palette"],
    _excluded7 = ["unstable_system"];

function useFormProps(_) {
  var htmlProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _objectSpread(_objectSpread({}, htmlProps), {}, {
    className: cx(htmlProps.className, ComponentsTheme.FORM)
  });
}

function useFormInputOptions(_ref) {
  var _ref$unstable_system = _ref.unstable_system;
  _ref$unstable_system = _ref$unstable_system === void 0 ? {} : _ref$unstable_system;

  var _ref$unstable_system$ = _ref$unstable_system.fill,
      fill = _ref$unstable_system$ === void 0 ? 'outline' : _ref$unstable_system$,
      system = _objectWithoutProperties(_ref$unstable_system, _excluded$8),
      options = _objectWithoutProperties(_ref, _excluded2$4);

  var isInvalid = Boolean(unstable_getIn(options.touched, options.name) && unstable_getIn(options.errors, options.name));
  return _objectSpread({
    unstable_system: _objectSpread(_objectSpread({
      fill: fill
    }, system), {}, {
      palette: isInvalid ? 'danger' : system.palette
    })
  }, options);
}

function useFormMessageOptions(_ref2) {
  var _ref2$unstable_system = _ref2.unstable_system,
      system = _ref2$unstable_system === void 0 ? {} : _ref2$unstable_system,
      options = _objectWithoutProperties(_ref2, _excluded3$1);

  var isInvalid = Boolean(unstable_getIn(options.errors, options.name));
  return _objectSpread({
    unstable_system: _objectSpread(_objectSpread({}, system), {}, {
      palette: isInvalid ? 'danger' : system.palette || 'success'
    })
  }, options);
}

function useFormMessageProps(_) {
  var htmlProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _objectSpread(_objectSpread({}, htmlProps), {}, {
    className: cx(htmlProps.className, ComponentsTheme.FORM_MESSAGE)
  });
}

function useFormLabelProps(_) {
  var htmlProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _objectSpread(_objectSpread({}, htmlProps), {}, {
    className: cx(htmlProps.className, ComponentsTheme.FORM_LABEL)
  });
}

function useFormGroupOptions(_ref3) {
  var _ref3$unstable_system = _ref3.unstable_system;
  _ref3$unstable_system = _ref3$unstable_system === void 0 ? {} : _ref3$unstable_system;

  var _ref3$unstable_system2 = _ref3$unstable_system.fill,
      fill = _ref3$unstable_system2 === void 0 ? 'outline' : _ref3$unstable_system2,
      system = _objectWithoutProperties(_ref3$unstable_system, _excluded4$1),
      options = _objectWithoutProperties(_ref3, _excluded5);

  var isInvalid = Boolean(unstable_getIn(options.touched, options.name) && unstable_getIn(options.errors, options.name));
  return _objectSpread({
    unstable_system: _objectSpread(_objectSpread({
      fill: fill
    }, system), {}, {
      palette: isInvalid ? 'danger' : system.palette
    })
  }, options);
}

function useFormGroupProps(_) {
  var htmlProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _objectSpread(_objectSpread({}, htmlProps), {}, {
    className: cx(htmlProps.className, ComponentsTheme.FORM_GROUP)
  });
}

function useFormRemoveButtonOptions(_ref4) {
  var _ref4$unstable_system = _ref4.unstable_system;
  _ref4$unstable_system = _ref4$unstable_system === void 0 ? {} : _ref4$unstable_system;

  var _ref4$unstable_system2 = _ref4$unstable_system.palette,
      palette = _ref4$unstable_system2 === void 0 ? 'danger' : _ref4$unstable_system2,
      system = _objectWithoutProperties(_ref4$unstable_system, _excluded6),
      options = _objectWithoutProperties(_ref4, _excluded7);

  return _objectSpread({
    unstable_system: _objectSpread({
      palette: palette
    }, system)
  }, options);
}

function useGroupProps(_) {
  var htmlProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _objectSpread(_objectSpread({}, htmlProps), {}, {
    className: cx(htmlProps.className, ComponentsTheme.GROUP)
  });
}

function useInputProps(_) {
  var htmlProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _objectSpread(_objectSpread({}, htmlProps), {}, {
    className: cx(htmlProps.className, ComponentsTheme.INPUT)
  });
}

var _excluded$7 = ["palette", "fill"],
    _excluded2$3 = ["unstable_system"],
    _excluded3 = ["wrapElement"],
    _excluded4 = ["children"];

function useMenuBarProps(_ref) {
  var orientation = _ref.orientation;
  var htmlProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _objectSpread(_objectSpread({}, htmlProps), {}, {
    className: cx(ComponentsTheme.MENU_BAR, orientation === 'horizontal' ? ComponentsTheme.FLEX_ROW : ComponentsTheme.FLEX_COLUMN, htmlProps.className)
  });
}

function useMenuItemProps(_ref2) {
  var orientation = _ref2.orientation;
  var htmlProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _objectSpread(_objectSpread({}, htmlProps), {}, {
    className: cx(ComponentsTheme.MENU_ITEM, orientation === 'horizontal' ? ComponentsTheme.MENU_ITEM_ROW : ComponentsTheme.MENU_ITEM_COLUMN, htmlProps.className)
  });
} // eslint-disable-next-line unicorn/no-useless-undefined


var OrientationContext = /*#__PURE__*/createContext(undefined);

function useMenuOptions(_ref3) {
  var _options$unstable_pop, _options$unstable_pop2;

  var _ref3$unstable_system = _ref3.unstable_system;
  _ref3$unstable_system = _ref3$unstable_system === void 0 ? {} : _ref3$unstable_system;

  var _ref3$unstable_system2 = _ref3$unstable_system.palette,
      palette = _ref3$unstable_system2 === void 0 ? 'background' : _ref3$unstable_system2,
      _ref3$unstable_system3 = _ref3$unstable_system.fill,
      fill = _ref3$unstable_system3 === void 0 ? 'opaque' : _ref3$unstable_system3,
      system = _objectWithoutProperties(_ref3$unstable_system, _excluded$7),
      options = _objectWithoutProperties(_ref3, _excluded2$3);

  var parentOrientation = useContext(OrientationContext);

  var unstable_system = _objectSpread({
    palette: palette,
    fill: fill
  }, system);

  var transform = (_options$unstable_pop = (_options$unstable_pop2 = options.unstable_popoverStyles) === null || _options$unstable_pop2 === void 0 ? void 0 : _options$unstable_pop2.transform) !== null && _options$unstable_pop !== void 0 ? _options$unstable_pop : '';

  if (parentOrientation === 'vertical' && options.orientation === 'vertical') {
    return _objectSpread(_objectSpread({}, options), {}, {
      unstable_system: unstable_system,
      unstable_popoverStyles: _objectSpread(_objectSpread({}, options.unstable_popoverStyles), {}, {
        transform: "".concat(transform, " translate3d(0px, -0.3em, 0px)")
      })
    });
  }

  return _objectSpread(_objectSpread({}, options), {}, {
    unstable_system: unstable_system
  });
}

function useMenuProps(options) {
  var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var htmlWrapElement = _ref4.wrapElement,
      htmlProps = _objectWithoutProperties(_ref4, _excluded3);

  var wrapElement = useCallback(function (element) {
    if (htmlWrapElement) {
      element = htmlWrapElement(element);
    }

    return /*#__PURE__*/jsx(OrientationContext.Provider, {
      value: options.orientation,
      children: element
    });
  }, [htmlWrapElement, options.orientation]);
  return _objectSpread(_objectSpread({}, htmlProps), {}, {
    wrapElement: wrapElement,
    className: cx(ComponentsTheme.MENU, htmlProps.className)
  });
}

function useMenuButtonProps(options) {
  var _options$unstable_ori;

  var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var children = _ref5.children,
      htmlProps = _objectWithoutProperties(_ref5, _excluded4);

  var placement = (_options$unstable_ori = options.unstable_originalPlacement) !== null && _options$unstable_ori !== void 0 ? _options$unstable_ori : options.placement;
  var dir = placement ? placement.split('-')[0] : undefined;
  var svg = dir ? {
    top: /*#__PURE__*/jsx("svg", {
      viewBox: "0 0 50 43.3",
      children: /*#__PURE__*/jsx("polygon", {
        points: "25 0 0 43.3 50 43.3 25 0"
      })
    }),
    bottom: /*#__PURE__*/jsx("svg", {
      viewBox: "0 0 50 43.3",
      children: /*#__PURE__*/jsx("polygon", {
        points: "25 43.3 50 0 0 0 25 43.3"
      })
    }),
    right: /*#__PURE__*/jsx("svg", {
      viewBox: "0 0 43.3 50",
      children: /*#__PURE__*/jsx("polygon", {
        points: "43.3 25 0 0 0 50 43.3 25"
      })
    }),
    left: /*#__PURE__*/jsx("svg", {
      viewBox: "0 0 43.3 50",
      children: /*#__PURE__*/jsx("polygon", {
        points: "0 25 43.3 50 43.3 0 0 25"
      })
    })
  }[dir] : null;
  return _objectSpread(_objectSpread({}, htmlProps), {}, {
    children: typeof children === 'function' ? function (props) {
      var child = children(props);
      return /*#__PURE__*/cloneElement(child, {
        children: /*#__PURE__*/jsxs(Fragment, {
          children: [child.props.children, svg]
        })
      });
    } : /*#__PURE__*/jsxs(Fragment, {
      children: [children, svg]
    }),
    className: cx(ComponentsTheme.MENU_BUTTON, dir === 'left' ? ComponentsTheme.MENU_BUTTON_LEFT : ComponentsTheme.MENU_BUTTON_RIGHT, children && dir === 'left' && ComponentsTheme.MENU_BUTTON_NESTED_LEFT, children && dir === 'right' && ComponentsTheme.MENU_BUTTON_NESTED_RIGHT, htmlProps.className)
  });
}

function useMenuItemCheckboxProps(_) {
  var htmlProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _objectSpread(_objectSpread({}, htmlProps), {}, {
    className: cx(ComponentsTheme.MENU_ITEM_CHECKBOX, htmlProps.className)
  });
}

function useMenuItemRadioProps(_) {
  var htmlProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _objectSpread(_objectSpread({}, htmlProps), {}, {
    className: cx(ComponentsTheme.MENU_ITEM_CHECKBOX, htmlProps.className)
  });
}

function useMenuGroupProps(_) {
  var htmlProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _objectSpread(_objectSpread({}, htmlProps), {}, {
    className: cx(ComponentsTheme.MENU_GROUP, htmlProps.className)
  });
}

var _excluded$6 = ["palette", "fill"],
    _excluded2$2 = ["unstable_system"];

function usePopoverOptions(_ref) {
  var _ref$unstable_system = _ref.unstable_system;
  _ref$unstable_system = _ref$unstable_system === void 0 ? {} : _ref$unstable_system;

  var _ref$unstable_system$ = _ref$unstable_system.palette,
      palette = _ref$unstable_system$ === void 0 ? 'background' : _ref$unstable_system$,
      _ref$unstable_system$2 = _ref$unstable_system.fill,
      fill = _ref$unstable_system$2 === void 0 ? 'opaque' : _ref$unstable_system$2,
      system = _objectWithoutProperties(_ref$unstable_system, _excluded$6),
      options = _objectWithoutProperties(_ref, _excluded2$2);

  return _objectSpread({
    unstable_system: _objectSpread({
      palette: palette,
      fill: fill
    }, system)
  }, options);
}

function usePopoverProps(_) {
  var htmlProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _objectSpread(_objectSpread({}, htmlProps), {}, {
    className: cx(ComponentsTheme.POPOVER, htmlProps.className)
  });
}

function usePopoverArrowProps(_) {
  var htmlProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _objectSpread({
    'data-arrow': ''
  }, htmlProps);
}

function useRoleProps(_) {
  var htmlProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _objectSpread(_objectSpread({}, htmlProps), {}, {
    className: cx(ComponentsTheme.ROLE, htmlProps.className)
  });
}

function useSeparatorProps(_) {
  var htmlProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _objectSpread(_objectSpread({}, htmlProps), {}, {
    className: cx(htmlProps.className, ComponentsTheme.SEPARATOR)
  });
}

function useTabProps(_) {
  var htmlProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _objectSpread(_objectSpread({}, htmlProps), {}, {
    className: cx(ComponentsTheme.TAB, htmlProps.className)
  });
}

function useTabListProps(_) {
  var htmlProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _objectSpread(_objectSpread({}, htmlProps), {}, {
    className: cx(htmlProps.className, ComponentsTheme.TAB_LIST)
  });
}

function useTabbableProps(_) {
  var htmlProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _objectSpread(_objectSpread({}, htmlProps), {}, {
    className: cx(htmlProps.className, ComponentsTheme.TABBABLE)
  });
}

function useToolbarProps(_) {
  var htmlProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _objectSpread(_objectSpread({}, htmlProps), {}, {
    className: cx(htmlProps.className, ComponentsTheme.TOOLBAR)
  });
}

var _excluded$5 = ["palette", "fill"],
    _excluded2$1 = ["unstable_system"];

function useTooltipOptions(_ref) {
  var _ref$unstable_system = _ref.unstable_system;
  _ref$unstable_system = _ref$unstable_system === void 0 ? {} : _ref$unstable_system;

  var _ref$unstable_system$ = _ref$unstable_system.palette,
      palette = _ref$unstable_system$ === void 0 ? 'foreground' : _ref$unstable_system$,
      _ref$unstable_system$2 = _ref$unstable_system.fill,
      fill = _ref$unstable_system$2 === void 0 ? 'opaque' : _ref$unstable_system$2,
      system = _objectWithoutProperties(_ref$unstable_system, _excluded$5),
      options = _objectWithoutProperties(_ref, _excluded2$1);

  return _objectSpread({
    unstable_system: _objectSpread({
      palette: palette,
      fill: fill
    }, system)
  }, options);
}

function useTooltipProps(_) {
  var htmlProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _objectSpread(_objectSpread({}, htmlProps), {}, {
    className: cx(ComponentsTheme.TOOLTIP, htmlProps.className)
  });
}

var system = /*#__PURE__*/Object.freeze({
  __proto__: null,
  useButtonOptions: useButtonOptions,
  useButtonProps: useButtonProps,
  useCompositeItemOptions: useCompositeItemOptions,
  useCompositeItemProps: useCompositeItemProps,
  useDialogOptions: useDialogOptions,
  useDialogProps: useDialogProps,
  useDialogBackdropProps: useDialogBackdropProps,
  useFormProps: useFormProps,
  useFormInputOptions: useFormInputOptions,
  useFormMessageOptions: useFormMessageOptions,
  useFormMessageProps: useFormMessageProps,
  useFormLabelProps: useFormLabelProps,
  useFormGroupOptions: useFormGroupOptions,
  useFormGroupProps: useFormGroupProps,
  useFormRemoveButtonOptions: useFormRemoveButtonOptions,
  useGroupProps: useGroupProps,
  useInputProps: useInputProps,
  useMenuBarProps: useMenuBarProps,
  useMenuItemProps: useMenuItemProps,
  useMenuOptions: useMenuOptions,
  useMenuProps: useMenuProps,
  useMenuButtonProps: useMenuButtonProps,
  useMenuItemCheckboxProps: useMenuItemCheckboxProps,
  useMenuItemRadioProps: useMenuItemRadioProps,
  useMenuGroupProps: useMenuGroupProps,
  palette: palette$1,
  usePopoverOptions: usePopoverOptions,
  usePopoverProps: usePopoverProps,
  usePopoverArrowProps: usePopoverArrowProps,
  useRoleProps: useRoleProps,
  useSeparatorProps: useSeparatorProps,
  useTabProps: useTabProps,
  useTabListProps: useTabListProps,
  useTabbableProps: useTabbableProps,
  useToolbarProps: useToolbarProps,
  useTooltipOptions: useTooltipOptions,
  useTooltipProps: useTooltipProps
});
/**
 * @module
 *
 * The `ThemeProvider` to wrap your editor with when using these components.
 */

var ThemeContext = /*#__PURE__*/createContext({});
/**
 * Get the theme from the context and convert it to a style object which can be
 * attached to any element.
 *
 * The theme provided is deeply merged with the parent theme.
 */

function useTheme() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}; // Get theme from parent context.

  var parent = useContext(ThemeContext);
  var theme = useMemo(function () {
    var _props$theme;

    return deepMerge(parent, (_props$theme = props.theme) !== null && _props$theme !== void 0 ? _props$theme : {});
  }, [parent, props.theme]);
  var style = useMemo(function () {
    return createThemeVariables(theme).styles;
  }, [theme]);
  var className = cx(THEME, props.className);
  return useMemo(function () {
    return {
      style: style,
      className: className,
      theme: theme
    };
  }, [style, className, theme]);
}
/**
 * This the `ThemeProvider`. Wrap your editor with it to customise the theming
 * of content within your editor.
 *
 * Please be aware that this wraps your component in an extra dom layer.
 */


var ThemeProvider = function ThemeProvider(props) {
  var children = props.children,
      _props$as = props.as,
      Component = _props$as === void 0 ? 'div' : _props$as;

  var _useTheme = useTheme({
    theme: props.theme
  }),
      theme = _useTheme.theme,
      style = _useTheme.style,
      className = _useTheme.className;

  return /*#__PURE__*/jsx(Provider, {
    unstable_system: system,
    children: /*#__PURE__*/jsx(ThemeContext.Provider, {
      value: theme,
      children: /*#__PURE__*/jsx(Component, {
        style: style,
        className: className,
        children: children
      })
    })
  });
};

var _excluded$4 = ["children"];
/**
 * A controlled version of the Reakit `Dialog` component.
 */

var ControlledDialogComponent = function ControlledDialogComponent(props) {
  var visible = props.visible,
      children = props.children,
      _props$backdrop = props.backdrop,
      backdrop = _props$backdrop === void 0 ? false : _props$backdrop,
      onUpdate = props.onUpdate;
  var previousVisible = usePrevious(visible);
  var dialogState = useDialogState({
    visible: visible,
    modal: false
  });
  var themeProps = useTheme({});
  useEffect(function () {
    if (visible !== previousVisible) {
      if (visible) {
        dialogState.show();
      } else {
        dialogState.hide();
      }

      return;
    }

    if (visible !== dialogState.visible) {
      onUpdate(dialogState.visible);
    }
  }, [onUpdate, previousVisible, visible, dialogState]);
  var dialog =
  /*#__PURE__*/
  // <Portal>
  jsx(Dialog, _objectSpread(_objectSpread({}, dialogState), {}, {
    role: "alertdialog",
    tabIndex: 0,
    style: themeProps.style,
    unstable_autoFocusOnHide: false,
    unstable_autoFocusOnShow: false // unstable_={false}
    ,
    children: /*#__PURE__*/jsx(Themed, {
      children: children
    })
  })) // </Portal>
  ;
  return backdrop ? /*#__PURE__*/jsx(DialogBackdrop, _objectSpread(_objectSpread({}, dialogState), {}, {
    children: dialog
  })) : dialog;
};

var Themed = function Themed(props) {
  var children = props.children,
      themeProps = _objectWithoutProperties(props, _excluded$4);

  var _useTheme = useTheme(themeProps),
      style = _useTheme.style,
      className = _useTheme.className;

  return /*#__PURE__*/jsx("div", {
    style: style,
    className: className,
    children: children
  });
};

var ComponentItem;
/**
 * Handle click events.
 */

(function (ComponentItem) {
  ComponentItem["Toolbar"] = "toolbar";
  ComponentItem["ToolbarButton"] = "toolbar-button";
  ComponentItem["ToolbarCommandButton"] = "toolbar-command-button";
  ComponentItem["ToolbarComponent"] = "toolbar-component";
  ComponentItem["ToolbarElement"] = "toolbar-element";
  ComponentItem["ToolbarSeparator"] = "toolbar-separator";
  ComponentItem["ToolbarGroup"] = "toolbar-group";
  ComponentItem["ToolbarMenu"] = "toolbar-menu";
  ComponentItem["MenuBar"] = "menu-bar";
  ComponentItem["MenuBarGroup"] = "menu-bar-group";
  ComponentItem["MenuDropdown"] = "menu-bar-dropdown";
  ComponentItem["MenuSeparator"] = "menu-separator";
  ComponentItem["MenuPane"] = "menu-pane";
  ComponentItem["MenuCommandPane"] = "menu-command-pane";
  ComponentItem["MenuGroup"] = "menu-group";
  ComponentItem["MenuAction"] = "menu-action";
  ComponentItem["MenuCommandAction"] = "menu-command-action";
})(ComponentItem || (ComponentItem = {}));
/**
 * Get the value from the option passed into the command.
 */


function getCommandOptionValue(value, commandProps) {
  return isFunction(value) ? value(commandProps) : value;
}
/**
 * Checks whether the first element in an array is a string and assumes the
 * whole array is a string array.
 */


function isStringArray(array) {
  return isString(array[0]);
}
/**
 * Get the string value from the available UI Shortcut.
 */


function getUiShortcutString(uiShortcut, attrs) {
  var _shortcut, _ref, _uiShortcut$find;

  if (isString(uiShortcut)) {
    return uiShortcut;
  }

  if (!isArray(uiShortcut)) {
    return uiShortcut.shortcut;
  }

  if (isStringArray(uiShortcut)) {
    var _uiShortcut$;

    return (_uiShortcut$ = uiShortcut[0]) !== null && _uiShortcut$ !== void 0 ? _uiShortcut$ : '';
  }

  return (_shortcut = (_ref = (_uiShortcut$find = uiShortcut.find(function (shortcut) {
    return isEqual(shortcut.attrs, attrs);
  })) !== null && _uiShortcut$find !== void 0 ? _uiShortcut$find : uiShortcut[0]) === null || _ref === void 0 ? void 0 : _ref.shortcut) !== null && _shortcut !== void 0 ? _shortcut : '';
}
/**
 * How to display the symbols.
 */


var CASINGS = {
  title: function title(value) {
    return capitalize(value);
  },
  upper: function upper(value) {
    return value.toLocaleUpperCase();
  },
  lower: function lower(value) {
    return value.toLocaleLowerCase();
  }
};
/**
 * Get a normalized shortcut as a string.
 */

function getShortcutString(shortcut, options) {
  var _options$casing = options.casing,
      casing = _options$casing === void 0 ? 'title' : _options$casing,
      _options$namedAsSymbo = options.namedAsSymbol,
      namedAsSymbol = _options$namedAsSymbo === void 0 ? false : _options$namedAsSymbo,
      _options$modifierAsSy = options.modifierAsSymbol,
      modifierAsSymbol = _options$modifierAsSy === void 0 ? true : _options$modifierAsSy,
      _options$separator = options.separator,
      separator = _options$separator === void 0 ? ' ' : _options$separator,
      t = options.t;
  var symbols = getShortcutSymbols(shortcut);
  var stringSymbols = [];
  var transform = CASINGS[casing];

  var _iterator = _createForOfIteratorHelper(symbols),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var sym = _step.value;

      if (sym.type === 'char') {
        stringSymbols.push(transform(sym.key));
        continue;
      }

      if (sym.type === 'named') {
        var _sym$symbol;

        var _value = namedAsSymbol === true || isArray(namedAsSymbol) && includes(namedAsSymbol, sym.key) ? (_sym$symbol = sym.symbol) !== null && _sym$symbol !== void 0 ? _sym$symbol : t(sym.i18n) : t(sym.i18n);

        stringSymbols.push(transform(_value));
        continue;
      }

      var value = modifierAsSymbol === true || isArray(modifierAsSymbol) && includes(modifierAsSymbol, sym.key) ? sym.symbol : t(sym.i18n);
      stringSymbols.push(transform(value));
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return stringSymbols.join(separator);
}

var _excluded$3 = ["menuItems", "label", "menuLabel", "icon"];

var MenuGroup = function MenuGroup(props) {
  var menuState = props.menuState,
      group = props.item;
  var items = group.items,
      label = group.label,
      role = group.role,
      separator = group.separator;
  var startSeparator = includes(['start', 'both'], separator) && /*#__PURE__*/jsx(MenuSeparator, _objectSpread({}, menuState));
  var endSeparator = includes(['end', 'both'], separator) && /*#__PURE__*/jsx(MenuSeparator, _objectSpread({}, menuState));
  return /*#__PURE__*/jsxs(Fragment, {
    children: [startSeparator, /*#__PURE__*/jsx(MenuGroup$1, _objectSpread(_objectSpread({}, menuState), {}, {
      "aria-label": label,
      children: items.map(function (item, index) {
        switch (item.type) {
          case ComponentItem.MenuPane:
            return /*#__PURE__*/jsx(MenuPane, {
              menuState: menuState,
              item: item
            }, index);

          case ComponentItem.MenuCommandPane:
            return /*#__PURE__*/jsx(MenuCommandPane, {
              menuState: menuState,
              item: item,
              role: role
            }, index);

          case ComponentItem.MenuDropdown:
            return /*#__PURE__*/jsx(MenuDropdown, {
              item: item,
              menuState: menuState
            }, index);
        }
      })
    })), endSeparator]
  });
};

var MenuPane = function MenuPane(props) {
  return /*#__PURE__*/jsx(MenuItem, _objectSpread({}, props.menuState));
};

var MenuCommandPane = function MenuCommandPane(props) {
  var _ref, _item$refocusEditor, _commands$commandName, _commands$commandName2, _active$options$name, _active$options$name2; // Gather all the hooks used for this component.


  var context = useRemirrorContext();
  var menuState = props.menuState,
      item = props.item,
      role = props.role;
  var commands = useCommands();
  var chain = useChainedCommands();

  var _useHelpers = useHelpers(),
      getCommandOptions = _useHelpers.getCommandOptions;

  var _useI18n = useI18n(),
      t = _useI18n.t;

  var autoFocus = (_ref = (_item$refocusEditor = item.refocusEditor) !== null && _item$refocusEditor !== void 0 ? _item$refocusEditor : props.autoFocus) !== null && _ref !== void 0 ? _ref : false; // Will cause the editor to rerender for each state update.

  var active = useActive();
  var commandName = item.commandName,
      attrs = item.attrs,
      _item$displayShortcut = item.displayShortcut,
      displayShortcut = _item$displayShortcut === void 0 ? true : _item$displayShortcut;
  var options = getCommandOptions(commandName);

  if (!options) {
    return /*#__PURE__*/jsxs("span", {
      children: ["Not found: ", commandName]
    });
  }

  var enabled = (_commands$commandName = (_commands$commandName2 = commands[commandName]) === null || _commands$commandName2 === void 0 ? void 0 : _commands$commandName2.isEnabled(attrs)) !== null && _commands$commandName !== void 0 ? _commands$commandName : false;
  var isActive = (_active$options$name = (_active$options$name2 = active[options.name]) === null || _active$options$name2 === void 0 ? void 0 : _active$options$name2.call(active, attrs)) !== null && _active$options$name !== void 0 ? _active$options$name : false;
  var commandProps = {
    active: isActive,
    attrs: attrs,
    enabled: enabled,
    t: t
  };
  var label = getCommandOptionValue(options.label, commandProps);
  var icon = getCommandOptionValue(options.icon, commandProps);
  var shortcutString = displayShortcut && options.shortcut ? "".concat(getShortcutString(getUiShortcutString(options.shortcut, attrs !== null && attrs !== void 0 ? attrs : {}), {
    t: t
  })) : undefined;

  var onClick = function onClick(event) {
    var _chain$commandName;

    if (item.onClick) {
      item.onClick(event, context);
      return;
    }

    if (options.disableChaining) {
      var _commands$commandName3;

      (_commands$commandName3 = commands[commandName]) === null || _commands$commandName3 === void 0 ? void 0 : _commands$commandName3.call(commands, attrs);
      return;
    }

    var command = (_chain$commandName = chain[commandName]) === null || _chain$commandName === void 0 ? void 0 : _chain$commandName.call(chain, attrs);

    if (autoFocus) {
      var _command$focus;

      command === null || command === void 0 ? void 0 : (_command$focus = command.focus) === null || _command$focus === void 0 ? void 0 : _command$focus.call(command);
    }

    command === null || command === void 0 ? void 0 : command.run();
  };

  return /*#__PURE__*/jsxs(BaseMenuPane, {
    menuState: menuState,
    disabled: !enabled,
    focusable: enabled,
    onClick: onClick,
    active: isActive,
    role: role,
    children: [icon && /*#__PURE__*/jsx(Box, {
      as: "span",
      className: ComponentsTheme.MENU_PANE_ICON,
      children: /*#__PURE__*/jsx(CommandIconComponent, {
        icon: icon
      })
    }), /*#__PURE__*/jsx(Box, {
      as: "span",
      className: ComponentsTheme.MENU_PANE_LABEL,
      children: label
    }), shortcutString && /*#__PURE__*/jsx(Box, {
      as: "span",
      className: ComponentsTheme.MENU_PANE_SHORTCUT,
      children: shortcutString
    })]
  });
}; // type MenuDropdownProps = SubMenuDropdownProps | MenuBarDropdownProps;


var MenuDropdown = function MenuDropdown(props) {
  var menuState = props.menuState,
      item = props.item;
  var items = item.items,
      label = item.label,
      menuLabel = item.menuLabel;
  return /*#__PURE__*/jsx(MenuItem, _objectSpread(_objectSpread({
    as: DropdownComponent
  }, menuState), {}, {
    menuItems: items,
    label: label,
    menuLabel: menuLabel
  }));
};
/**
 * A dropdown menu which can be composed together with other dropdown menus.
 */


var DropdownComponent = /*#__PURE__*/forwardRef(function (props, ref) {
  var menuState = useMenuState();

  var menuItems = props.menuItems,
      Label = props.label,
      menuLabel = props.menuLabel,
      icon = props.icon,
      rest = _objectWithoutProperties(props, _excluded$3);

  var labelElement;
  var label = menuLabel;

  if (isString(Label)) {
    var _label;

    (_label = label) !== null && _label !== void 0 ? _label : label = Label;
  } else if (Label != null) {
    labelElement = /*#__PURE__*/jsx(Label, {
      menuState: menuState
    });
  }

  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs(MenuButton, _objectSpread(_objectSpread(_objectSpread({}, menuState), rest), {}, {
      ref: ref,
      "aria-label": label,
      children: [labelElement && /*#__PURE__*/jsx(Box, {
        as: "span",
        className: ComponentsTheme.MENU_DROPDOWN_LABEL,
        children: labelElement
      }), icon && /*#__PURE__*/jsx(Box, {
        as: "span",
        className: ComponentsTheme.MENU_PANE_ICON,
        children: /*#__PURE__*/jsx(CommandIconComponent, {
          icon: icon
        })
      })]
    })), /*#__PURE__*/jsx(MenuComponent, {
      items: menuItems,
      menuState: menuState,
      label: label
    })]
  });
});
DropdownComponent.displayName = 'Dropdown';
/**
 * A menu without the menu button trigger. The menu is opened and closed via the
 * `open` prop.
 */

var MenuComponent = function MenuComponent(props) {
  var open = props.open,
      items = props.items,
      menuState = props.menuState,
      label = props.label;
  var isControlled = useRef(open != null);
  useEffect(function () {
    !(isControlled.current === (open != null)) ? process.env.NODE_ENV !== "production" ? invariant(false, {
      code: ErrorConstant.REACT_COMPONENTS,
      message: 'The controllable menu must either be controlled with a boolean value for `open` or uncontrolled (null | undefined value for `open`) for the lifetime of the component.'
    }) : invariant(false) : void 0;

    if (!isControlled.current) {
      return;
    }

    open ? menuState.show() : menuState.hide();
  }, [open, menuState]);
  return /*#__PURE__*/jsx(Menu, _objectSpread(_objectSpread({}, menuState), {}, {
    "aria-label": label,
    children: items.map(function (item, index) {
      switch (item.type) {
        case ComponentItem.MenuSeparator:
          return /*#__PURE__*/createElement(MenuSeparator, _objectSpread(_objectSpread({}, menuState), {}, {
            key: index
          }));

        case ComponentItem.MenuPane:
          return /*#__PURE__*/jsx(MenuPane, {
            menuState: menuState,
            item: item
          }, index);

        case ComponentItem.MenuCommandPane:
          return /*#__PURE__*/jsx(MenuCommandPane, {
            menuState: menuState,
            item: item
          }, index);

        case ComponentItem.MenuGroup:
          return /*#__PURE__*/jsx(MenuGroup, {
            item: item,
            menuState: menuState
          }, index);

        case ComponentItem.MenuDropdown:
          return /*#__PURE__*/jsx(MenuDropdown, {
            item: item,
            menuState: menuState
          }, index);

        default:
          return /*#__PURE__*/jsx(Fragment, {});
      }
    })
  }));
};

var MenuBar = function MenuBar(props) {
  var menuState = useMenuBarState();
  var items = props.item.items;
  return /*#__PURE__*/jsx(MenuBar$1, _objectSpread(_objectSpread({}, menuState), {}, {
    children: items.map(function (item) {
      switch (item.type) {
        case ComponentItem.MenuSeparator:
          return /*#__PURE__*/jsx(MenuSeparator, _objectSpread({}, menuState));

        case ComponentItem.MenuBarGroup:
          return /*#__PURE__*/jsx(MenuBarGroup, {
            item: item,
            menuState: menuState
          });

        case ComponentItem.MenuDropdown:
          return /*#__PURE__*/jsx(MenuDropdown, {
            item: item,
            menuState: menuState
          });
      }
    })
  }));
};

var MenuBarGroup = function MenuBarGroup(props) {
  var menuState = props.menuState,
      item = props.item;
  return /*#__PURE__*/jsx(MenuGroup$1, _objectSpread(_objectSpread({}, menuState), {}, {
    "aria-label": item.label,
    children: item.items.map(function (item) {
      switch (item.type) {
        case ComponentItem.MenuDropdown:
          return /*#__PURE__*/jsx(MenuDropdown, {
            item: item,
            menuState: menuState
          });
      }
    })
  }));
};

var BaseMenuPane = function BaseMenuPane(props) {
  var state = props.menuState,
      _children = props.children,
      tooltip = props.tooltip,
      disabled = props.disabled,
      focusable = props.focusable,
      onClick = props.onClick,
      tooltipClass = props.tooltipClass,
      active = props.active,
      className = props.className;
  var tooltipState = useTooltipState({
    gutter: 5
  });
  var themeProps = useTheme({
    className: tooltipClass
  });
  var checked = props.role ? active ? 'true' : 'false' : undefined;
  var role = props.role === 'checkbox' ? 'menuitemcheckbox' : props.role === 'radio' ? 'menuitemradio' : undefined;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(TooltipReference, _objectSpread(_objectSpread({}, tooltipState), {}, {
      children: function children(props) {
        return /*#__PURE__*/jsx(MenuItem, _objectSpread(_objectSpread(_objectSpread({}, props), state), {}, {
          role: role,
          "aria-checked": checked,
          disabled: disabled,
          focusable: focusable,
          onClick: onClick,
          className: cx(className, ComponentsTheme.MENU_PANE, active && ComponentsTheme.MENU_PANE_ACTIVE),
          children: _children
        }));
      }
    })), tooltip && /*#__PURE__*/jsx(Tooltip, _objectSpread(_objectSpread({}, tooltipState), {}, {
      style: themeProps.style,
      className: cx(themeProps.className),
      children: tooltip
    }))]
  });
};
/**
 * This is the menu that can be placed at the top of the editor.
 */


var Toolbar = function Toolbar(props) {
  var items = props.items,
      loop = props.loop,
      label = props.label,
      refocusEditor = props.refocusEditor,
      focusable = props.focusable;
  var toolbarState = useToolbarState({
    loop: loop
  });
  var focusableProps = focusable === false ? {
    focusable: false,
    tabIndex: -1
  } : {};
  return /*#__PURE__*/jsx(Toolbar$1, _objectSpread(_objectSpread(_objectSpread({}, toolbarState), focusableProps), {}, {
    "aria-label": label,
    children: items.map(getToolbarComponent({
      toolbarState: toolbarState,
      refocusEditor: refocusEditor
    }))
  }));
};

var ToolbarCommandButton = function ToolbarCommandButton(props) {
  var _ref, _item$refocusEditor, _commands$name$isEnab, _commands$name, _active$options$name, _active$options$name2; // Gather all the hooks used for this component.


  var toolbarState = props.toolbarState,
      item = props.item;
  var commands = useCommands();
  var chain = useChainedCommands();

  var _useHelpers = useHelpers(),
      getCommandOptions = _useHelpers.getCommandOptions;

  var context = useRemirrorContext();

  var _useI18n = useI18n(),
      t = _useI18n.t;

  var refocusEditor = (_ref = (_item$refocusEditor = item.refocusEditor) !== null && _item$refocusEditor !== void 0 ? _item$refocusEditor : props.refocusEditor) !== null && _ref !== void 0 ? _ref : false; // Will cause the editor to rerender for each state update.

  var active = useActive();
  var display = item.display,
      name = item.commandName,
      attrs = item.attrs,
      _item$displayShortcut = item.displayShortcut,
      displayShortcut = _item$displayShortcut === void 0 ? true : _item$displayShortcut;
  var options = getCommandOptions(name);

  if (!options) {
    return /*#__PURE__*/jsx(Fragment, {});
  }

  var enabled = (_commands$name$isEnab = (_commands$name = commands[name]) === null || _commands$name === void 0 ? void 0 : _commands$name.isEnabled(attrs)) !== null && _commands$name$isEnab !== void 0 ? _commands$name$isEnab : false;
  var isActive = (_active$options$name = (_active$options$name2 = active[options.name]) === null || _active$options$name2 === void 0 ? void 0 : _active$options$name2.call(active, attrs)) !== null && _active$options$name !== void 0 ? _active$options$name : false;
  var commandProps = {
    active: isActive,
    attrs: attrs,
    enabled: enabled,
    t: t
  };
  var description = getCommandOptionValue(options.description, commandProps);
  var label = getCommandOptionValue(options.label, commandProps);
  var icon = getCommandOptionValue(options.icon, commandProps);
  var shortcutString = displayShortcut && options.shortcut ? " (".concat(getShortcutString(getUiShortcutString(options.shortcut, attrs !== null && attrs !== void 0 ? attrs : {}), {
    t: t
  }), ")") : '';

  var onClick = function onClick(event) {
    var _chain$name;

    if (item.onClick) {
      item.onClick(event, context);
      return;
    }

    if (options.disableChaining) {
      var _commands$name2;

      (_commands$name2 = commands[name]) === null || _commands$name2 === void 0 ? void 0 : _commands$name2.call(commands, attrs);
      return;
    }

    var command = (_chain$name = chain[name]) === null || _chain$name === void 0 ? void 0 : _chain$name.call(chain, attrs);

    if (refocusEditor) {
      var _command$focus;

      command === null || command === void 0 ? void 0 : (_command$focus = command.focus) === null || _command$focus === void 0 ? void 0 : _command$focus.call(command);
    }

    command === null || command === void 0 ? void 0 : command.run();
  };

  switch (display) {
    case 'icon':
      {
        !(label && icon) ? process.env.NODE_ENV !== "production" ? invariant(false, {
          code: ErrorConstant.REACT_CONTROLLED,
          message: "Both label and icon are needed for the command: ".concat(name, " in extension: ").concat(options.name)
        }) : invariant(false) : void 0;
        return /*#__PURE__*/jsxs(BaseToolbarButton, {
          toolbarState: toolbarState,
          disabled: !enabled,
          focusable: enabled,
          tooltip: "".concat(label).concat(shortcutString),
          onClick: onClick,
          active: isActive,
          children: [/*#__PURE__*/jsx(VisuallyHidden, {
            children: label
          }), /*#__PURE__*/jsx(CommandIconComponent, {
            icon: icon
          })]
        });
      }

    case 'label':
      {
        !(label && description) ? process.env.NODE_ENV !== "production" ? invariant(false, {
          code: ErrorConstant.REACT_CONTROLLED,
          message: "Both label and description are needed for the command: ".concat(name, " in extension: ").concat(options.name)
        }) : invariant(false) : void 0;
        return /*#__PURE__*/jsx(BaseToolbarButton, {
          toolbarState: toolbarState,
          disabled: !enabled,
          focusable: enabled,
          tooltip: "".concat(description).concat(shortcutString),
          onClick: onClick,
          active: isActive,
          children: label
        });
      }

    default:
      {
        !(label && icon) ? process.env.NODE_ENV !== "production" ? invariant(false, {
          code: ErrorConstant.REACT_CONTROLLED,
          message: "Icon, label and description are needed for the command: ".concat(name, " in extension: ").concat(options.name)
        }) : invariant(false) : void 0;
        return /*#__PURE__*/jsxs(BaseToolbarButton, {
          toolbarState: toolbarState,
          disabled: !enabled,
          focusable: enabled,
          tooltip: "".concat(label).concat(shortcutString),
          onClick: onClick,
          active: isActive,
          children: [display === 'label-icon' && /*#__PURE__*/jsxs(Box, {
            as: "span",
            children: [" ", label]
          }), /*#__PURE__*/jsx(CommandIconComponent, {
            icon: icon
          }), ' ', display === 'icon-label' && /*#__PURE__*/jsxs(Box, {
            as: "span",
            children: [" ", label]
          })]
        });
      }
  }
};

var BaseToolbarButton = function BaseToolbarButton(props) {
  var toolbarState = props.toolbarState,
      _children = props.children,
      tooltip = props.tooltip,
      disabled = props.disabled,
      focusable = props.focusable,
      onClick = props.onClick,
      tooltipClass = props.tooltipClass,
      active = props.active,
      className = props.className;
  var tooltipState = useTooltipState({
    gutter: 5
  });
  var themeProps = useTheme({
    className: tooltipClass
  });
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(TooltipReference, _objectSpread(_objectSpread({}, tooltipState), {}, {
      children: function children(props) {
        return /*#__PURE__*/jsx(ToolbarItem, _objectSpread(_objectSpread(_objectSpread({}, props), toolbarState), {}, {
          as: Button,
          disabled: disabled,
          focusable: focusable,
          onClick: onClick,
          className: cx(className, active && ComponentsTheme.BUTTON_ACTIVE),
          children: _children
        }));
      }
    })), tooltip && /*#__PURE__*/jsx(Tooltip, _objectSpread(_objectSpread({}, tooltipState), {}, {
      style: themeProps.style,
      className: cx(themeProps.className),
      children: tooltip
    }))]
  });
};
/**
 * The divider component
 */


var ToolbarSeparator = function ToolbarSeparator(props) {
  return /*#__PURE__*/jsx(ToolbarSeparator$1, _objectSpread({}, props.toolbarState));
};
/**
 * The [[`Group`]] component
 */


var ToolbarGroup = function ToolbarGroup(props) {
  var toolbarState = props.toolbarState,
      refocusEditor = props.refocusEditor,
      group = props.item;
  var startSeparator = includes(['start', 'both'], group.separator) && /*#__PURE__*/jsx(ToolbarSeparator, {
    toolbarState: toolbarState
  });
  var endSeparator = includes(['end', 'both'], group.separator) && /*#__PURE__*/jsx(ToolbarSeparator, {
    toolbarState: toolbarState
  });
  return /*#__PURE__*/jsxs(Fragment, {
    children: [startSeparator, /*#__PURE__*/jsx(Group, {
      "aria-label": group.label,
      children: group.items.map(getToolbarComponent({
        toolbarState: toolbarState,
        refocusEditor: refocusEditor
      }))
    }), endSeparator]
  });
};

var ToolbarButton = function ToolbarButton(props) {
  var _ref2, _item$refocusEditor2;

  var toolbarState = props.toolbarState,
      focusable = props.focusable,
      item = props.item;
  var context = useRemirrorContext();
  var refocusEditor = (_ref2 = (_item$refocusEditor2 = item.refocusEditor) !== null && _item$refocusEditor2 !== void 0 ? _item$refocusEditor2 : props.refocusEditor) !== null && _ref2 !== void 0 ? _ref2 : false;
  var disabled = item.disabled,
      label = item.label,
      icon = item.icon,
      _item$active = item.active,
      active = _item$active === void 0 ? false : _item$active;
  var onClick = useCallback(function (event) {
    item.onClick(event, context);

    if (refocusEditor) {
      requestAnimationFrame(function () {
        return context.commands.focus();
      });
    }
  }, [refocusEditor, context, item]);
  return /*#__PURE__*/jsxs(BaseToolbarButton, {
    toolbarState: toolbarState,
    disabled: disabled,
    focusable: focusable,
    onClick: onClick,
    active: active,
    children: [/*#__PURE__*/jsx(Box, {
      as: "span",
      children: label
    }), icon && /*#__PURE__*/jsx(CommandIconComponent, {
      icon: icon
    })]
  });
};
/**
 * Create a mapping function for generating a toolbar component
 */


function getToolbarComponent(props) {
  // eslint-disable-next-line react/display-name
  return function (item, index, _) {
    var _item$key, _item$key2, _item$key3, _item$key4, _item$key5, _item$key6;

    var toolbarState = props.toolbarState,
        refocusEditor = props.refocusEditor;

    switch (item.type) {
      case ComponentItem.ToolbarCommandButton:
        return /*#__PURE__*/jsx(ToolbarCommandButton, {
          item: item,
          toolbarState: toolbarState,
          refocusEditor: refocusEditor
        }, (_item$key = item.key) !== null && _item$key !== void 0 ? _item$key : index);

      case ComponentItem.ToolbarButton:
        return /*#__PURE__*/jsx(ToolbarButton, {
          item: item,
          toolbarState: toolbarState,
          refocusEditor: refocusEditor
        }, (_item$key2 = item.key) !== null && _item$key2 !== void 0 ? _item$key2 : index);

      case ComponentItem.ToolbarGroup:
        return /*#__PURE__*/jsx(ToolbarGroup, {
          item: item,
          toolbarState: toolbarState,
          refocusEditor: refocusEditor
        }, (_item$key3 = item.key) !== null && _item$key3 !== void 0 ? _item$key3 : index);

      case ComponentItem.ToolbarSeparator:
        return /*#__PURE__*/jsx(ToolbarSeparator, {
          toolbarState: toolbarState
        }, (_item$key4 = item.key) !== null && _item$key4 !== void 0 ? _item$key4 : index);

      case ComponentItem.ToolbarElement:
        return item.element;

      case ComponentItem.ToolbarComponent:
        return /*#__PURE__*/jsx(item.Component, {
          Wrapper: ToolbarItem,
          toolbarState: toolbarState
        }, (_item$key5 = item.key) !== null && _item$key5 !== void 0 ? _item$key5 : index);

      case ComponentItem.ToolbarMenu:
        return /*#__PURE__*/jsx(ToolbarMenu, {
          item: item,
          toolbarState: toolbarState
        }, (_item$key6 = item.key) !== null && _item$key6 !== void 0 ? _item$key6 : index);
    }
  };
}

var ToolbarMenu = function ToolbarMenu(props) {
  var item = props.item,
      toolbarState = props.toolbarState;
  var items = item.items,
      label = item.label,
      menuLabel = item.menuLabel;
  return /*#__PURE__*/jsx(ToolbarItem, _objectSpread(_objectSpread({}, toolbarState), {}, {
    as: DropdownComponent,
    menuItems: items,
    label: label,
    menuLabel: menuLabel
  }));
};

var isSafari = isUA('Mac') && !isUA('Chrome') && isUA('Safari');

function applyStyles(styles) {
  return function (prevStyles) {
    if (styles && !shallowEqual(prevStyles, styles)) {
      return styles;
    }

    return prevStyles;
  };
}

function usePopper() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _props$gutter = props.gutter,
      gutter = _props$gutter === void 0 ? 12 : _props$gutter,
      _props$placement = props.placement,
      sealedPlacement = _props$placement === void 0 ? 'bottom' : _props$placement,
      _props$flip = props.flip,
      flip = _props$flip === void 0 ? true : _props$flip,
      sealedOffset = props.offset,
      _props$preventOverflo = props.preventOverflow,
      preventOverflow = _props$preventOverflo === void 0 ? true : _props$preventOverflo,
      _props$fixed = props.fixed,
      fixed = _props$fixed === void 0 ? false : _props$fixed,
      _props$visible = props.visible,
      visible = _props$visible === void 0 ? false : _props$visible;
  var popper = useRef(null);
  var referenceRef = useRef();
  var popperRef = useRef();
  var arrowRef = useRef();

  var _useState = useState(sealedPlacement),
      _useState2 = _slicedToArray(_useState, 2),
      originalPlacement = _useState2[0],
      place = _useState2[1];

  var _useState3 = useState(sealedPlacement),
      _useState4 = _slicedToArray(_useState3, 2),
      placement = _useState4[0],
      setPlacement = _useState4[1];

  var _useState5 = useState(sealedOffset || [0, gutter]),
      _useState6 = _slicedToArray(_useState5, 1),
      offset = _useState6[0];

  var _useState7 = useState({
    position: fixed ? 'fixed' : 'absolute',
    left: '-9999999px',
    top: '-9999999px'
  }),
      _useState8 = _slicedToArray(_useState7, 2),
      popoverStyles = _useState8[0],
      setPopoverStyles = _useState8[1];

  var _useState9 = useState({}),
      _useState10 = _slicedToArray(_useState9, 2),
      arrowStyles = _useState10[0],
      setArrowStyles = _useState10[1];

  var update = useCallback(function () {
    if (popper.current) {
      popper.current.forceUpdate();
      return true;
    }

    return false;
  }, []);
  var updateState = useCallback(function (state) {
    if (state.placement) {
      setPlacement(state.placement);
    }

    if (state.styles) {
      setPopoverStyles(applyStyles(state.styles.popper));

      if (arrowRef.current) {
        setArrowStyles(applyStyles(state.styles.arrow));
      }
    }
  }, []);
  useLayoutEffect(function () {
    if (referenceRef.current && popperRef.current) {
      popper.current = createPopper(referenceRef.current, popperRef.current, {
        // https://popper.js.org/docs/v2/constructors/#options
        placement: originalPlacement,
        strategy: fixed ? 'fixed' : 'absolute',
        // Safari needs styles to be applied in the first render, otherwise
        // hovering over the popover when it gets visible for the first time
        // will change its dimensions unexpectedly.
        onFirstUpdate: isSafari ? updateState : undefined,
        modifiers: [{
          // https://popper.js.org/docs/v2/modifiers/event-listeners/
          name: 'eventListeners',
          enabled: visible
        }, {
          // https://popper.js.org/docs/v2/modifiers/apply-styles/
          name: 'applyStyles',
          enabled: false
        }, {
          // https://popper.js.org/docs/v2/modifiers/flip/
          name: 'flip',
          enabled: flip,
          options: {
            padding: 8
          }
        }, {
          // https://popper.js.org/docs/v2/modifiers/offset/
          name: 'offset',
          options: {
            offset: offset
          }
        }, {
          // https://popper.js.org/docs/v2/modifiers/prevent-overflow/
          name: 'preventOverflow',
          enabled: preventOverflow,
          options: {
            tetherOffset: function tetherOffset() {
              var _arrowRef$current;

              return ((_arrowRef$current = arrowRef.current) === null || _arrowRef$current === void 0 ? void 0 : _arrowRef$current.clientWidth) || 0;
            }
          }
        }, {
          // https://popper.js.org/docs/v2/modifiers/arrow/
          name: 'arrow',
          enabled: !!arrowRef.current,
          options: {
            element: arrowRef.current
          }
        }, {
          // https://popper.js.org/docs/v2/modifiers/#custom-modifiers
          name: 'updateState',
          phase: 'write',
          requires: ['computeStyles'],
          enabled: visible,
          fn: function fn(_ref) {
            var state = _ref.state;
            return updateState(state);
          }
        }]
      });
    }

    return function () {
      if (popper.current) {
        popper.current.destroy();
        popper.current = null;
      }
    };
  }, [originalPlacement, fixed, visible, flip, offset, preventOverflow, updateState]); // Ensure that the popover will be correctly positioned with an additional
  // update.

  useEffect(function () {
    if (!visible) {
      return;
    }

    var id = window.requestAnimationFrame(function () {
      var _popper$current;

      (_popper$current = popper.current) === null || _popper$current === void 0 ? void 0 : _popper$current.forceUpdate();
    });
    return function () {
      window.cancelAnimationFrame(id);
    };
  }, [visible]);
  return useMemo(function () {
    return {
      referenceRef: referenceRef,
      popperRef: popperRef,
      arrowRef: arrowRef,
      popoverStyles: popoverStyles,
      arrowStyles: arrowStyles,
      update: update,
      originalPlacement: originalPlacement,
      placement: placement,
      place: place
    };
  }, [arrowStyles, originalPlacement, placement, popoverStyles, update]);
}

var _excluded$2 = ["placement", "positioner", "animated", "animatedClass", "containerClass", "blurOnInactive", "enabled", "floatingLabel", "ignoredElements"],
    _excluded2 = ["actions", "animated", "placement", "positioner", "blurOnInactive", "ignoredElements", "enabled"];

function useMemoizedPosition(props) {
  var height = props.height,
      left = props.left,
      top = props.top,
      width = props.width;
  return useMemo(function () {
    return {
      height: height,
      left: left,
      top: top,
      width: width
    };
  }, [height, left, top, width]);
}

var FloatingWrapper = function FloatingWrapper(props) {
  var containerClass = props.containerClass,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'right-end' : _props$placement,
      positioner = props.positioner,
      children = props.children,
      _props$blurOnInactive = props.blurOnInactive,
      blurOnInactive = _props$blurOnInactive === void 0 ? false : _props$blurOnInactive,
      _props$ignoredElement = props.ignoredElements,
      ignoredElements = _props$ignoredElement === void 0 ? [] : _props$ignoredElement,
      _props$enabled = props.enabled,
      enabled = _props$enabled === void 0 ? true : _props$enabled,
      floatingLabel = props.floatingLabel,
      _props$hideWhenInvisi = props.hideWhenInvisible,
      hideWhenInvisible = _props$hideWhenInvisi === void 0 ? true : _props$hideWhenInvisi,
      _props$renderOutsideE = props.renderOutsideEditor,
      renderOutsideEditor = _props$renderOutsideE === void 0 ? false : _props$renderOutsideE;

  var _useEditorFocus = useEditorFocus({
    blurOnInactive: blurOnInactive,
    ignoredElements: ignoredElements
  }),
      _useEditorFocus2 = _slicedToArray(_useEditorFocus, 1),
      isFocused = _useEditorFocus2[0];

  var _usePositioner = usePositioner(function () {
    var active = isFocused && enabled;
    var refinedPositioner = getPositioner(positioner);
    return refinedPositioner.active(active);
  }, [isFocused, enabled, renderOutsideEditor]),
      ref = _usePositioner.ref,
      active = _usePositioner.active,
      height = _usePositioner.height,
      left = _usePositioner.x,
      top = _usePositioner.y,
      width = _usePositioner.width,
      visible = _usePositioner.visible;

  var shouldShow = (hideWhenInvisible ? visible : true) && active;
  var position = useMemoizedPosition({
    height: height,
    left: left,
    top: top,
    width: width
  });

  var _usePopper = usePopper({
    placement: placement,
    visible: visible
  }),
      popperRef = _usePopper.popperRef,
      referenceRef = _usePopper.referenceRef,
      popoverStyles = _usePopper.popoverStyles,
      update = _usePopper.update;

  var floatingElement = /*#__PURE__*/jsx("div", {
    "aria-label": floatingLabel,
    ref: popperRef,
    style: popoverStyles,
    className: cx(ComponentsTheme.FLOATING_POPOVER, containerClass),
    children: shouldShow && children
  });

  if (!renderOutsideEditor) {
    floatingElement = /*#__PURE__*/jsx(PositionerPortal, {
      children: floatingElement
    });
  }

  useLayoutEffect(function () {
    update();
  }, [shouldShow, update, height, left, top, width]);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(PositionerPortal, {
      children: /*#__PURE__*/jsx("span", {
        className: ExtensionPositionerTheme.POSITIONER,
        style: {
          top: position.top,
          left: position.left,
          width: position.width,
          height: position.height
        },
        ref: composeRefs(ref, referenceRef)
      })
    }), floatingElement]
  });
};

var FloatingToolbar = function FloatingToolbar(props) {
  var placement = props.placement,
      positioner = props.positioner,
      _props$animated = props.animated,
      animated = _props$animated === void 0 ? 200 : _props$animated,
      _props$animatedClass = props.animatedClass,
      animatedClass = _props$animatedClass === void 0 ? ComponentsTheme.ANIMATED_POPOVER : _props$animatedClass,
      containerClass = props.containerClass,
      blurOnInactive = props.blurOnInactive,
      enabled = props.enabled,
      floatingLabel = props.floatingLabel,
      ignoredElements = props.ignoredElements,
      toolbarProps = _objectWithoutProperties(props, _excluded$2);

  var floatingWrapperProps = {
    placement: placement,
    positioner: positioner,
    animated: animated,
    animatedClass: animatedClass,
    containerClass: containerClass,
    blurOnInactive: blurOnInactive,
    enabled: enabled,
    floatingLabel: floatingLabel,
    ignoredElements: ignoredElements
  };
  return /*#__PURE__*/jsx(FloatingWrapper, _objectSpread(_objectSpread({}, floatingWrapperProps), {}, {
    children: /*#__PURE__*/jsx(Toolbar, _objectSpread(_objectSpread({}, toolbarProps), {}, {
      refocusEditor: false
    }))
  }));
};
/**
 * Render a component into the editors positioner widget using `createPortal`
 * from `react-dom`.
 */


var PositionerPortal = function PositionerPortal(props) {
  var container = useHelpers().getPositionerWidget();
  return /*#__PURE__*/createPortal( /*#__PURE__*/jsx(Fragment, {
    children: props.children
  }), container);
};
/**
 * Respond to user queries in the editor.
 */


var FloatingActionsMenu = function FloatingActionsMenu(props) {
  var actions = props.actions,
      _props$animated2 = props.animated,
      animated = _props$animated2 === void 0 ? false : _props$animated2,
      _props$placement2 = props.placement,
      placement = _props$placement2 === void 0 ? 'right-end' : _props$placement2,
      _props$positioner = props.positioner,
      positioner = _props$positioner === void 0 ? 'nearestWord' : _props$positioner,
      blurOnInactive = props.blurOnInactive,
      ignoredElements = props.ignoredElements,
      _props$enabled2 = props.enabled,
      enabled = _props$enabled2 === void 0 ? true : _props$enabled2,
      floatingWrapperProps = _objectWithoutProperties(props, _excluded2);

  var _useSuggest = useSuggest({
    char: '/',
    name: 'actions-dropdown',
    matchOffset: 0
  }),
      change = _useSuggest.change;

  var query = change === null || change === void 0 ? void 0 : change.query.full;
  var menuState = useMenuState({
    unstable_virtual: true,
    wrap: true,
    loop: true
  });
  var items = (query ? matchSorter(actions, query, {
    keys: ['tags', 'description', function (item) {
      var _item$description$rep, _item$description;

      return (_item$description$rep = (_item$description = item.description) === null || _item$description === void 0 ? void 0 : _item$description.replace(/\W/g, '')) !== null && _item$description$rep !== void 0 ? _item$description$rep : '';
    }],
    threshold: matchSorter.rankings.CONTAINS
  }) : actions).map(function (item) {
    return item.type === ComponentItem.MenuAction ? _objectSpread(_objectSpread({}, item), {}, {
      type: ComponentItem.MenuPane
    }) : _objectSpread(_objectSpread({}, item), {}, {
      type: ComponentItem.MenuCommandPane
    });
  });
  return /*#__PURE__*/jsxs(FloatingWrapper, _objectSpread(_objectSpread({
    enabled: !!query,
    positioner: positioner,
    placement: placement,
    animated: animated,
    blurOnInactive: blurOnInactive,
    ignoredElements: ignoredElements
  }, floatingWrapperProps), {}, {
    children: [/*#__PURE__*/jsx("div", {
      style: {
        width: 50,
        height: 50,
        background: 'red'
      }
    }), /*#__PURE__*/jsx(MenuComponent, {
      open: !!query && enabled,
      items: items,
      menuState: menuState
    })]
  }));
};

var EmojiFromCdn = function EmojiFromCdn(props) {
  return /*#__PURE__*/jsx("img", {
    role: "presentation",
    className: ExtensionEmojiTheme.EMOJI_IMAGE,
    "aria-label": props.annotation,
    alt: props.annotation,
    src: props.url
  });
};

var emptyList = [];
/**
 * This component renders the emoji suggestion dropdown for the user.
 */

var EmojiPopupComponent = function EmojiPopupComponent() {
  var _state$list;

  var _useEmoji = useEmoji(),
      state = _useEmoji.state,
      getMenuProps = _useEmoji.getMenuProps,
      getItemProps = _useEmoji.getItemProps,
      indexIsHovered = _useEmoji.indexIsHovered,
      indexIsSelected = _useEmoji.indexIsSelected;

  var enabled = !!state;
  return /*#__PURE__*/jsx(FloatingWrapper, {
    positioner: "cursor",
    enabled: enabled,
    placement: "auto-end",
    children: /*#__PURE__*/jsx("div", _objectSpread(_objectSpread({}, getMenuProps()), {}, {
      children: enabled && ((_state$list = state === null || state === void 0 ? void 0 : state.list) !== null && _state$list !== void 0 ? _state$list : emptyList).map(function (emoji, index) {
        var _emoji$shortcodes$, _emoji$shortcodes;

        var isHighlighted = indexIsSelected(index);
        var isHovered = indexIsHovered(index);
        var shortcode = (_emoji$shortcodes$ = (_emoji$shortcodes = emoji.shortcodes) === null || _emoji$shortcodes === void 0 ? void 0 : _emoji$shortcodes[0]) !== null && _emoji$shortcodes$ !== void 0 ? _emoji$shortcodes$ : emoji.annotation;
        return /*#__PURE__*/jsxs("div", _objectSpread(_objectSpread({
          className: cx(ExtensionEmojiTheme.EMOJI_POPUP_ITEM, isHighlighted && ExtensionEmojiTheme.EMOJI_POPUP_HIGHLIGHT, isHovered && ExtensionEmojiTheme.EMOJI_POPUP_HOVERED)
        }, getItemProps({
          item: emoji,
          index: index
        })), {}, {
          children: [/*#__PURE__*/jsx("span", {
            className: ExtensionEmojiTheme.EMOJI_POPUP_CHAR,
            children: /*#__PURE__*/jsx(EmojiFromCdn, _objectSpread({}, emoji))
          }), /*#__PURE__*/jsxs("span", {
            className: ExtensionEmojiTheme.EMOJI_POPUP_NAME,
            children: [":", shortcode, ":"]
          })]
        }), emoji.emoji);
      })
    }))
  });
};

var _excluded$1 = ["onChange", "ItemComponent", "ZeroItemsComponent"];

function useMentionAtomChangeHandler(props) {
  var onChange = props.onChange,
      state = props.state;
  useEffect(function () {
    onChange(state);
  }, [state, onChange]);
}
/**
 * This component renders the emoji suggestion dropdown for the user.
 */


function MentionAtomPopupComponent(props) {
  var _useCommands = useCommands(),
      focus = _useCommands.focus;

  var onChange = props.onChange,
      _props$ItemComponent = props.ItemComponent,
      ItemComponent = _props$ItemComponent === void 0 ? DefaultItemComponent : _props$ItemComponent,
      _props$ZeroItemsCompo = props.ZeroItemsComponent,
      ZeroItemsComponent = _props$ZeroItemsCompo === void 0 ? DefaultZeroItemsComponent : _props$ZeroItemsCompo,
      hookProps = _objectWithoutProperties(props, _excluded$1);

  var _useMentionAtom = useMentionAtom(hookProps),
      state = _useMentionAtom.state,
      getMenuProps = _useMentionAtom.getMenuProps,
      getItemProps = _useMentionAtom.getItemProps,
      indexIsHovered = _useMentionAtom.indexIsHovered,
      indexIsSelected = _useMentionAtom.indexIsSelected;

  useMentionAtomChangeHandler({
    state: state,
    onChange: onChange
  });
  return /*#__PURE__*/jsx(FloatingWrapper, {
    positioner: "cursor",
    enabled: !!state,
    placement: "auto-end",
    renderOutsideEditor: true,
    children: /*#__PURE__*/jsx("div", _objectSpread(_objectSpread({}, getMenuProps()), {}, {
      className: cx(ExtensionMentionAtomTheme.MENTION_ATOM_POPUP_WRAPPER),
      children: !!state && isEmptyArray(hookProps.items) ? /*#__PURE__*/jsx(ZeroItemsComponent, {}) : hookProps.items.map(function (item, index) {
        var isHighlighted = indexIsSelected(index);
        var isHovered = indexIsHovered(index);
        return /*#__PURE__*/jsx("div", _objectSpread(_objectSpread({
          className: cx(ExtensionMentionAtomTheme.MENTION_ATOM_POPUP_ITEM, isHighlighted && ExtensionMentionAtomTheme.MENTION_ATOM_POPUP_HIGHLIGHT, isHovered && ExtensionMentionAtomTheme.MENTION_ATOM_POPUP_HOVERED)
        }, getItemProps({
          onClick: function onClick() {
            state === null || state === void 0 ? void 0 : state.command(item);
            focus();
          },
          item: item,
          index: index
        })), {}, {
          children: /*#__PURE__*/jsx(ItemComponent, {
            item: item,
            state: state
          })
        }), item.id);
      })
    }))
  });
}

function DefaultItemComponent(props) {
  return /*#__PURE__*/jsx("span", {
    className: ExtensionMentionAtomTheme.MENTION_ATOM_POPUP_NAME,
    children: props.item.label
  });
}

var DefaultZeroItemsComponent = function DefaultZeroItemsComponent() {
  var _useI18n = useI18n(),
      t = _useI18n.t;

  return /*#__PURE__*/jsx("span", {
    className: ExtensionMentionAtomTheme.MENTION_ATOM_ZERO_ITEMS,
    children: t(ReactComponentMessages.NO_ITEMS_AVAILABLE)
  });
};

function _checkPrivateRedeclaration(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}

function _classPrivateFieldInitSpec(obj, privateMap, value) {
  _checkPrivateRedeclaration(obj, privateMap);

  privateMap.set(obj, value);
}

var _excluded = ["MetricsComponent"];

var TableSizeEditorComponent = function TableSizeEditorComponent(_ref) {
  var MetricsComponent = _ref.MetricsComponent,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState({
    columns: 1,
    rows: 1
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var instance = useRef(new TableSizeRef({
    props: props,
    state: state,
    setState: setState
  }));
  instance.current.props = props;
  instance.current.state = state;
  useEffect(function () {
    return instance.current.unmount;
  }, []);
  var rows = Math.max(5, state.rows);
  var columns = Math.max(5, state.columns);

  if (rows === state.rows) {
    rows = Math.min(MAX_SIZE, rows + 1);
  }

  if (columns === state.columns) {
    columns = Math.min(MAX_SIZE, columns + 1);
  }

  var cells = [];
  var ii = 0;
  var y = 0;
  var width = 0;
  var height = 0;

  while (ii < rows) {
    y += GUTTER_SIZE;
    var jj = 0;
    var x = 0;

    while (jj < columns) {
      x += GUTTER_SIZE;

      var _selected = ii < rows && jj < columns;

      cells.push( /*#__PURE__*/jsx(TableSizeEditorCell, {
        selected: _selected,
        x: x,
        y: y
      }, "".concat(String(ii), "-").concat(String(jj))));
      x += CELL_SIZE;
      width = x + GUTTER_SIZE;
      jj++;
    }

    y += CELL_SIZE;
    height = y + GUTTER_SIZE;
    ii++;
  }

  var metrics = MetricsComponent ? /*#__PURE__*/jsx(MetricsComponent, {
    rows: rows,
    columns: columns
  }) : "".concat(rows, " x ").concat(columns);
  return /*#__PURE__*/jsxs("div", {
    className: ComponentsTheme.TABLE_SIZE_EDITOR,
    ref: instance.current.ref,
    children: [/*#__PURE__*/jsx("div", {
      className: ComponentsTheme.TABLE_SIZE_EDITOR_BODY,
      onMouseDown: instance.current.onMouseDown,
      onMouseEnter: instance.current.onMouseEnter,
      style: {
        width: width,
        height: height
      },
      children: cells
    }), /*#__PURE__*/jsx("div", {
      className: ComponentsTheme.TABLE_SIZE_EDITOR_FOOTER,
      children: metrics
    })]
  });
};

var GUTTER_SIZE = 5;
var CELL_SIZE = 16;
var MAX_SIZE = 20;

var TableSizeEditorCell = function TableSizeEditorCell(props) {
  return /*#__PURE__*/jsx("div", {
    className: cx(ComponentsTheme.TABLE_SIZE_EDITOR_CELL, props.selected && ComponentsTheme.TABLE_SIZE_EDITOR_CELL_SELECTED),
    style: {
      top: props.y,
      left: props.x
    }
  });
};

var _targetX = /*#__PURE__*/new WeakMap();

var _targetY = /*#__PURE__*/new WeakMap();

var _mouseX = /*#__PURE__*/new WeakMap();

var _mouseY = /*#__PURE__*/new WeakMap();

var _animationFrame = /*#__PURE__*/new WeakMap();

var _entered = /*#__PURE__*/new WeakMap();

var TableSizeRef = /*#__PURE__*/function () {
  function TableSizeRef(_ref2) {
    var _this = this;

    _classCallCheck(this, TableSizeRef);

    var props = _ref2.props,
        state = _ref2.state,
        setState = _ref2.setState;

    _classPrivateFieldInitSpec(this, _targetX, {
      writable: true,
      value: 0
    });

    _classPrivateFieldInitSpec(this, _targetY, {
      writable: true,
      value: 0
    });

    _classPrivateFieldInitSpec(this, _mouseX, {
      writable: true,
      value: 0
    });

    _classPrivateFieldInitSpec(this, _mouseY, {
      writable: true,
      value: 0
    });

    _classPrivateFieldInitSpec(this, _animationFrame, {
      writable: true,
      value: 0
    });

    _classPrivateFieldInitSpec(this, _entered, {
      writable: true,
      value: false
    });

    _defineProperty(this, "ref", /*#__PURE__*/createRef());

    _defineProperty(this, "onMouseEnter", function (event) {
      var node = event.currentTarget;

      if (node instanceof HTMLElement) {
        var rect = fromHtmlElement(node);
        var mouseX = Math.round(event.clientX);
        var mouseY = Math.round(event.clientY);

        _classPrivateFieldSet(_this, _targetX, rect.x);

        _classPrivateFieldSet(_this, _targetY, rect.y);

        _classPrivateFieldSet(_this, _mouseX, mouseX);

        _classPrivateFieldSet(_this, _mouseY, mouseY);

        if (!_classPrivateFieldGet(_this, _entered)) {
          _classPrivateFieldSet(_this, _entered, true);

          document.addEventListener('mousemove', _this.onMouseMove, true);
        }
      }
    });

    _defineProperty(this, "onMouseMove", function (event) {
      if (_this.ref.current) {
        var elementRect = htmlElementToRect(_this.ref.current);
        var mouseRect = fromXY(event.screenX, event.screenY, 10);

        if (isIntersected(elementRect, mouseRect, 50)) {
          // This prevents `Reakit` from collapsing the editor`.
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }

      var mouseX = Math.round(event.clientX);
      var mouseY = Math.round(event.clientY);

      if (mouseX !== _classPrivateFieldGet(_this, _mouseX) || mouseY !== _classPrivateFieldGet(_this, _mouseY)) {
        _classPrivateFieldSet(_this, _mouseX, mouseX);

        _classPrivateFieldSet(_this, _mouseY, mouseY);

        _classPrivateFieldGet(_this, _animationFrame) && cancelAnimationFrame(_classPrivateFieldGet(_this, _animationFrame));

        _classPrivateFieldSet(_this, _animationFrame, requestAnimationFrame(_this.updateGridSize));
      }
    });

    _defineProperty(this, "onMouseDown", function (event) {
      event.preventDefault();

      _this.props.onSelect(_this.state);
    });

    _defineProperty(this, "updateGridSize", function () {
      _classPrivateFieldSet(_this, _animationFrame, 0);

      var x = _classPrivateFieldGet(_this, _mouseX) - _classPrivateFieldGet(_this, _targetX);

      var y = _classPrivateFieldGet(_this, _mouseY) - _classPrivateFieldGet(_this, _targetY);

      var rows = clamp({
        min: 1,
        max: MAX_SIZE,
        value: Math.ceil(y / (CELL_SIZE + GUTTER_SIZE))
      });
      var columns = clamp({
        min: 1,
        max: MAX_SIZE,
        value: Math.ceil(x / (CELL_SIZE + GUTTER_SIZE))
      });

      if (_this.state.rows !== rows || _this.state.columns !== columns) {
        _this.setState({
          rows: rows,
          columns: columns
        });
      }
    });

    this.props = props;
    this.state = state;
    this.setState = setState;
  }

  _createClass(TableSizeRef, [{
    key: "unmount",
    value: function unmount() {
      if (_classPrivateFieldGet(this, _entered)) {
        document.removeEventListener('mousemove', this.onMouseMove, true);
      }

      if (_classPrivateFieldGet(this, _animationFrame)) {
        cancelAnimationFrame(_classPrivateFieldGet(this, _animationFrame));
      }
    }
  }]);

  return TableSizeRef;
}();

function fromHtmlElement(element) {
  var _document$defaultView;

  var display = (_document$defaultView = document.defaultView) === null || _document$defaultView === void 0 ? void 0 : _document$defaultView.getComputedStyle(element).display;

  if (display === 'contents' && element.children.length === 1) {
    // el has no layout at all, use its children instead.
    return fromHtmlElement(element.children[0]);
  }

  return htmlElementToRect(element);
}

function htmlElementToRect(element) {
  var rect = element.getBoundingClientRect();
  return {
    x: rect.left,
    y: rect.top,
    width: rect.width,
    height: rect.height
  };
}

function isIntersected(r1, r2) {
  var padding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return !(r2.x - padding > r1.x + r1.width + padding || r2.x + r2.width + padding < r1.x - padding || r2.y - padding > r1.y + r1.height + padding || r2.y + r2.height + padding < r1.y - padding);
}

function fromXY(x, y) {
  var padding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return {
    x: x - padding,
    y: y - padding,
    width: padding * 2,
    height: padding * 2
  };
}

export { ColorPickerComponent, CommandIconComponent, ComponentItem, ControlledDialogComponent, DropdownComponent, EmojiPopupComponent, FloatingActionsMenu, FloatingToolbar, FloatingWrapper, MentionAtomPopupComponent, MenuBar, MenuComponent, PositionerPortal, TableSizeEditorComponent, ThemeProvider, Toolbar, useTheme };